<template>
  <v-dialog
    width="800"
    persistent
    v-model="dialog"
  >
    <v-form @submit.prevent.stop="submit()">
      <v-card>
        <v-card-title>
          Modifier un tag
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false" v-if="!isSubmitting">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-5">
          <v-alert
            :value="true"
            type="error"
            class="mb-2"
            v-if="errors.length"
          >
            Veuillez corriger les erreurs suivantes :
            <ul>
              <li v-for="(error, i) in errors" :key="`error${i}`">
                {{ error }}
              </li>
            </ul>
          </v-alert>
          <v-row justify="center" align="center">
            <v-col cols="3">
              <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :color="color"
                    v-bind="attrs"
                    v-on="on"
                    x-large
                    style="width: 100%;"
                  >
                    &nbsp;
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(color, index) in colors"
                    :key="index"
                  >
                    <v-btn
                      :color="color"
                      @click="selectColor(color)"
                      style="width: 100%;"
                    >
                      &nbsp;
                    </v-btn>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
            <v-col>
              <v-text-field v-model="label" label="Nom du tag*" outlined hide-details required autofocus />
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false" v-if="!isSubmitting">Annuler</v-btn>
          <v-btn color="primary darken-1" :loading="isSubmitting" type="submit" depressed>Modifier</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';

export default {
  props: {
    tag: {
      type: Object,
      required: false,
    },
    clientId: {
      type: Number,
      required: false,
    },
    makerId: {
      type: Number,
      required: false,
    },
  },

  data: () => ({
    isOpened: true,
    label: ``,
    color: ``,
    errors: [],
    isSubmitting: false,
  }),

  computed: {
    dialog: {
      get() { return this.isOpened; },
      set(isOpened) {
        this.isOpened = isOpened;
        if (!isOpened) {
          this.$emit(`close`);
        }
      },
    },
    ...mapState(`model/tag`, [`colors`]),
  },

  methods: {
    selectColor(color) {
      this.color = color;
    },
    async submit() {
      this.errors = [];
      if (!_.trim(this.label)) { this.errors.push(`Le nom du tag est obligatoire`); }

      if (this.errors.length) { return; }

      this.isSubmitting = true;
      const tagParams = {
        ...(this.tag || {}),
        label: this.label,
        color: this.color,
      };
      const tag = await this.$store.dispatch(`ui/tagDialog/updateTag`, tagParams);
      this.isSubmitting = false;

      if (tag) {
        this.$emit(`updated`, tag);
        this.$emit(`close`);
      } else {
        this.errors.push(`Impossible de modifier ce tag, réessayez`);
      }
    },
  },

  beforeMount() {
    if (this.tag && this.tag.id) {
      this.label = this.tag.label;
      this.color = this.tag.color;
    } else {
      this.color = this.colors[_.random(this.colors.length - 1)];
    }
  },
};
</script>

<style lang="scss">
</style>
